<template>
  <v-dialog v-model="EmailDetector.showing" persistent ligth max-width="700">
    <v-card>
      <v-btn
        icon
        absolute
        top
        right
        small
        @click="EmailDetector.showing = false"
      >
        <v-icon> mdi-close </v-icon>
      </v-btn>
      <v-row justify="center" no-gutters>
        <v-icon size="29" color="pink"> mdi-email-edit </v-icon>
        <v-card-title class="headline">
          {{ $t("messanger.chat.detect_emails") }} :
        </v-card-title>
      </v-row>
      <v-card-text class="text-center mt-3">
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <v-divider />
              <tr v-for="(email, index) in EmailDetector.emails" :key="index">
                <td>{{ email }}</td>
                <td>
                  <v-btn
                    :disabled="email === EmailDetector.curr_email"
                    icon
                    @click="change_email(email)"
                  >
                    <v-icon size="25" color="#1141ce"> mdi-email-edit </v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Email_detector",
  data() {
    return {};
  },
  computed: {
    EmailDetector() {
      return this.$store.state.EmailDetectBox;
    },
  },
  methods: {
    change_email(email) {
      this.$store
        .dispatch("confirmer/ask", {
          title: this.$t("show_box.title"),
          body: this.$t("show_box.email_change"),
          ligth: true,
        })
        .then((confirmation) => {
          if (confirmation) {
            const guid = this.EmailDetector.user_guid;
            this.$store
              .dispatch("SAVE_EMAIL", { email, guid })
              .then((res) => {
                console.log(res);
                if (res.success) {
                  this.$store.dispatch("setSnackbar", {
                    text: this.$t("messanger.chat.change_email.change") + email,
                    color: "success",
                    timeout: 3000,
                  });
                } else {
                  let msg = this.$t("messanger.chat.change_email.error");
                  if (res.message === "users_email_key")
                    msg = this.$t("messanger.chat.change_email.duplic");
                  this.$store.dispatch("setSnackbar", {
                    text: msg,
                    color: "error",
                    timeout: 3000,
                  });
                }
              })
              .catch((err) => console.log(err));
          }
          this.EmailDetector.showing = false;
        });
    },
  },
};
</script>
